import { render, staticRenderFns } from "./OrderProductList.vue?vue&type=template&id=0d16d61a&"
import script from "./OrderProductList.vue?vue&type=script&lang=ts&"
export * from "./OrderProductList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports